//View Keys
export default {
	fleetView_vehicle: 'Unit',
	fleetView_vehicles: 'Vehicles',
	fleetView_search: 'Search by {fields}',
	fleetView_vehicleStatus: 'Vehicle Status',
	fleetView_advancedFilters: 'Filter By',
	fleetView_clearFilters: 'Clear filters',
	fleetView_clearAll: 'Clear all',
	fleetView_vehicleGroups: 'Vehicle Groups',
	fleetView_select: 'Select',
	fleetView_starter: 'Starter Status',
	fleetView_drivers: 'Driver',
	fleetView_drivers_Default: 'Default Driver',
	fleetView_groups: 'Groups',
	fleetView_tags: 'Tags',
	fleetView_address: 'Address',
	fleetView_dataTime: 'Date / Time',
	fleetView_event: 'Event',
	fleetView_vin: 'VIN',
	fleetView_year: 'Year',
	fleetView_make: 'Make',
	fleetView_model: 'Model',
	fleetView_engineOdometer:'Odometer',
	fleetView_speed:'Speed',
	fleetView_speedLimit:'Posted Speed',
	fleetView_engineHours:'Engine Hours',
	fleetView_usn:'ESN',
	fleetView_imei:'IMEI',
	fleetView_events: 'Events',
	fleetView_times: 'Last Reported',
	fleetView_inspectionDeviceType: 'Inspection Device Type',
	fleetView_inspectionTagId: 'Inspection Tag ID',
	fleetView_powerUnitNumber: 'Power Unit Number',
	fleetView_icon:'Icon',
	fleetView_searchGroups: 'Search Groups',
	fleetView_notSupport: 'No Supported',
	fleetView_starterDisabled: 'Starter Disabled',
	fleetView_starterEnablePending: 'Starter Enable Pending',
	fleetView_starterDisablePending: 'Starter Disable Pending',
	fleetView_starter_enabled: 'Starter Enabled',
	fleetView_ScheduledStarter: 'Scheduled Starter',
	fleetView_ScheduledGroupStarter: 'Scheduled Group Starter',
	vehicleStatusModal_titleModalEnableDisable: 'Enable/Disable Starter',
	vehicleStatusModal_confirmationModalEnableDisable:
		'Are you sure you want to change the status starter?',
	vehicleStatusModal_currentStatus: 'Current Status',
	fleetView_disable: 'DISABLE',
	fleetView_enable: 'ENABLE',
	fleetView_outputs: 'Unit Outputs',
	fleetView_ping_toolTip: 'Send locate',
	fleetView_maintenance_company: 'Maintenance Company',
	fleetView_registration_country: 'Registration Country',
	fleetView_registration_state: 'Registration State',
	fleetView_registration_expiration_date: 'Registration Expiration Date',
	fleetView_engine_serial_number: 'Engine Serial Number',
	fleetView_chassis_serial_number: 'Chassis Serial Number',
	fleetView_license_plate: 'License Plate',
	fleetView_asset_type: 'Asset Type',
	fleetView_asset_subtype: 'Asset Subtype',
	fleetView_importUnits: "Import",

	fleetView_starter_no_permission: 'You don\'t have permission',
	fleetView_starter_no_supported: 'No Supported',
	fleetView_create_landmark: 'Create Landmark',
	All: 'All',
	None: 'None',
	fleetView_group: "Tag",
	fleetView_unit: "Unit",
	fleetView_vehicleTags: "Tags",

	fleetView_locate: "Locate",
	fleetView_enableDisableStarter: "Enable/Disable Starter",
	fleetView_outputs: "Outputs",

	fleetView_linkedDevice: "Linked Device",
	fleetView_unitOverViewPanel: "Vehicle Overview",
	fleetView_sdCardError: "SD card error",
	fleetView_warnings: "Device Warnings",
	fleetView_bulk_camera_config: "Bulk Camera Config",
	fleetView_bulk_units_issues: "Units w/ Issues",
	fleetView_bulk_offline_devices: "Offline Devices",
	fleetView_bulk_linked_units: "Linked Units",
	fleetView_bulk_more_filters: "More Filters",
};